import React, { useState } from "react";
import SolutionCard from "./SolutionCard";

// Updated Solutions / Work References Data
const solutionsData = [
  {
    id: 1,
    title: "Re-Development of LocateIT Limited Company Website",
    description:
      "The project involved a complete redesign and redevelopment of LocateIT Limited’s corporate website to achieve a modern, user-centric, and responsive digital experience. The initiative aimed to give the company’s online presence a facelift, integrating advanced features, dynamic content, and enhanced accessibility, while maintaining brand consistency across its portfolio, solutions, and resource sections. The updated platform reflects LocateIT’s position as a leading Geo-ICT and Data Innovation company and serves as a dynamic communication and engagement hub for clients, partners, and stakeholders.",
    date: "August - October 2025",
    number: "01",
    organization: "LocateIT Limited",
    client: "LocateIT Limited",
    image:
      "https://gyjbkzxtsxbpwjmbvilm.supabase.co/storage/v1/object/public/geo-portfolio-resources/LocateIT-portal.png",
    link: null,
    specificRoles: [
      "Led the coordination of the website’s research, prototype, and wireframe design phase.",
      "Supervised and implemented the development of the public-facing frontend using modern UI/UX standards.",
      "Engineered and deployed the backend logic and database integration to support dynamic content management.",
      "Oversaw the deployment and performance optimization of the production website.",
      "Integrated an LLM-powered chatbot (“Ask LoTI”) for intelligent client engagement and automated support.",
      "Collaborated with the marketing and technical teams to align web architecture with LocateIT’s 3i’s Framework and branding strategy.",
    ],
  },
  {
    id: 2,
    title:
      "Rangeland Monitoring and Management Decision Support System (RaM-DSS) Development - Northern Kenya",
    description:
      "The project involved the development of the Rangeland Monitoring and Management Decision Support System (RaM-DSS), a digital platform leveraging EO data to analyse rangeland indicators. The system facilitates real-time monitoring and forecasting of rangeland conditions to support data-driven decision-making by county governments and local communities, enhancing sustainable management of natural resources and livestock, while promoting rangeland regeneration and restoration.",
    date: "November 2024 - February 2025",
    number: "02",
    organization: "LocateIT Limited",
    client: "Mercy Corps",
    image:
      "https://gyjbkzxtsxbpwjmbvilm.supabase.co/storage/v1/object/public/geo-portfolio-resources/ram-dss.png",
    link: null,
    specificRoles: [
      "Led the overall coordination and management of the RaM-DSS development.",
      "Developed EO-derived products for rangeland monitoring and forecasting.",
      "Coordinated fieldwork exercises and data validation processes.",
      "Supervised data and software teams to ensure seamless workflow integration.",
      "Conducted stakeholder engagement meetings with county officials and partners.",
      "Facilitated end-user training to build capacity in interpreting rangeland indicators.",
    ],
  },
  {
    id: 3,
    title:
      "Geo-portal/System Development for Marine and Coastal Areas Management in North and West Africa (MarCNoWA)",
    description:
      "The project focused on the development of an integrated geo-portal designed to enhance marine and coastal resource management across North and West Africa. Implemented under the GMES & Africa programme, the system provides a centralized digital platform for data management, analysis, and dissemination. It enables participating countries to access and share EO-based information to support coastal planning, marine policy formulation, and sustainable Blue Economy initiatives. The system strengthens regional collaboration, harmonizes data workflows, and promotes evidence-based decision-making.",
    date: "November 2023 - September 2024",
    number: "03",
    organization: "LocateIT Limited",
    client: "University of Ghana (MarCNoWA Consortium)",
    image:
      "https://gyjbkzxtsxbpwjmbvilm.supabase.co/storage/v1/object/public/geo-portfolio-resources/marnowa-2.png",
    link: null,
    specificRoles: [
      "Led the overall coordination and management of the MarCNoWA Geoportal development.",
      "Coordinated client engagements.",
      "Processed and post-processed EO-derived products for marine and coastal monitoring.",
      "Configured back-end micro-processes for seamless integration with data pipelines.",
      "Supported system deployment and capacity building of regional administrators.",
    ],
  },
  {
    id: 4,
    title: "Development of a Web-Based GIS for the AGRI-CONNECT Programme",
    description:
      "This project centered on the creation of a web-based Geographic Information System (GIS) that supports monitoring and evaluation within the AGRI-CONNECT Programme in Tanzania. The GIS enables visualization of project activities, mapping of interventions, and data-driven coordination of tea, coffee, and horticulture value chain programs. It provides an interactive platform for tracking progress, improving planning, and enhancing visibility of development initiatives through spatial analytics and reporting dashboards.",
    date: "October 2023 - November 2024",
    number: "04",
    organization: "LocateIT Limited",
    client: "AGRI-CONNECT Programme (EU-Funded, Tanzania Government)",
    image:
      "https://gyjbkzxtsxbpwjmbvilm.supabase.co/storage/v1/object/public/geo-portfolio-resources/agriconnect-2.png",
    link: null,
    specificRoles: [
      "Led the overall coordination and management of the AGI-COONECT GIS development.",
      "Conducted comprehensive data validation and quality assurance for project datasets.",
      "Designed and implemented data entry templates for efficient information capture.",
      "Automated project data processing workflows using Python scripts.",
      "Collaborated with backend developers to ensure accurate data integration and dashboard functionality.",
      "Conducted end-user and IT administrator training to ensure system sustainability.",
    ],
  },
  {
    id: 5,
    title:
      "Coastal Geomorphology Mapping and Shoreline Erosion Geo-portal/System Development",
    description:
      "The project involved the design and development of a coastal erosion monitoring geoportal to assess and manage shoreline change dynamics in Comoros, Mauritius, Madagascar, and Seychelles. Implemented under the GMES & Africa programme, the system integrates EO data and field observations to track coastal geomorphology trends, identify erosion hotspots, and support sustainable coastal management planning. The platform enhances environmental monitoring, provides data visualization tools, and facilitates informed decision-making for coastal resilience and adaptation.",
    date: "September 2023 - February 2024",
    number: "05",
    organization: "LocateIT Limited",
    client: "RCMRD",
    image:
      "https://gyjbkzxtsxbpwjmbvilm.supabase.co/storage/v1/object/public/geo-portfolio-resources/cogeos.png",
    link: null,
    specificRoles: [
      "Developed coastal geomorphology and benthic habitat mapping products.",
      "Designed and pretested the geoportal to ensure functional compliance with project goals.",
      "Developed QGIS plugin workflows for coastal erosion analysis.",
      "Facilitated stakeholder engagement and end-user capacity-building sessions.",
    ],
  },
  {
    id: 6,
    title:
      "Location-Based Augmented Reality Project - Dedan Kimathi University of Technology",
    description:
      "An undergraduate project at the Institute of Geomatics, GIS and Remote Sensing (IGGReS), Dedan Kimathi University of Technology. The project focused on developing a location-based AR application to enhance campus navigation and visualization of spatial data using geo-referenced AR experiences and image-based ortho-maps, providing students with real-time interactive access to university landmarks.",
    date: "2022 - 2023",
    number: "06",
    organization: "Dedan Kimathi University of Technology",
    client: "IGGReS",
    image:
      "https://gyjbkzxtsxbpwjmbvilm.supabase.co/storage/v1/object/public/geo-portfolio-resources/dgmdekut.png",
    link: null,
    specificRoles: [
      "Designed and implemented geo-referenced AR experiences for campus navigation.",
      "Integrated image-based ortho-maps for interactive visualization.",
      "Developed a mobile-friendly interface for seamless access to AR features.",
    ],
  },
];

export default function SolutionListItems() {
  const [solutions] = useState(solutionsData);

  return (
    <div>
      <div className="workshop-header">
        <h2>Solutions</h2>
        <p>
          Professional projects and delivered solutions demonstrating applied
          expertise.
        </p>
      </div>
      {solutions.map((solution) => (
        <SolutionCard key={solution.id} {...solution} />
      ))}
    </div>
  );
}
